/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DueDateDto
 */
export interface DueDateDto {
    /**
     * 
     * @type {number}
     * @memberof DueDateDto
     */
    month: number;
    /**
     * 
     * @type {number}
     * @memberof DueDateDto
     */
    day: number;
}

/**
 * Check if a given object implements the DueDateDto interface.
 */
export function instanceOfDueDateDto(value: object): value is DueDateDto {
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('day' in value) || value['day'] === undefined) return false;
    return true;
}

export function DueDateDtoFromJSON(json: any): DueDateDto {
    return DueDateDtoFromJSONTyped(json, false);
}

export function DueDateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DueDateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'],
        'day': json['day'],
    };
}

export function DueDateDtoToJSON(json: any): DueDateDto {
    return DueDateDtoToJSONTyped(json, false);
}

export function DueDateDtoToJSONTyped(value?: DueDateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'day': value['day'],
    };
}

